import React, {useEffect, useState} from "react";
import $ from "jquery";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import {CORNER_SHELVES_POSITIONS, PAN_POSITIONS, SIDE_POSITIONS} from "../../bvSceneComponent/core/constants";
import ActionTypes from "../../../misc/actionTypes";
import {getFeatureIsLocked} from "../../../misc/helpers";
import {changeMessageBoxState, updateCanvasCount} from "../../../actions/actionFunctions";
import {featureInterface} from "../../../interfaces/featureInterface";
import {
  allSafetyPackageGroups, shouldUseSafetyPackage,
  updateFeatureGroupsWithNewSide
} from "../../bvSceneComponent/core/safetyPackageSidesLogic";
import {GRAB_BARS_POSITIONS} from "../../look/core/constants";

const getPositionName = (position) => {
  switch (position) {
    case CORNER_SHELVES_POSITIONS[0]:
    case CORNER_SHELVES_POSITIONS[3]:
      return "modalCheckboxPosition.top"
    case CORNER_SHELVES_POSITIONS[1]:
    case CORNER_SHELVES_POSITIONS[4]:
      return "modalCheckboxPosition.center"
    case CORNER_SHELVES_POSITIONS[2]:
    case CORNER_SHELVES_POSITIONS[5]:
      return "modalCheckboxPosition.bottom"
    case SIDE_POSITIONS[0]:
    case PAN_POSITIONS[0]:
    case GRAB_BARS_POSITIONS[3]:
      return "modalCheckboxPosition.left"
    case SIDE_POSITIONS[1]:
    case PAN_POSITIONS[2]:
    case GRAB_BARS_POSITIONS[4]:
      return "modalCheckboxPosition.right"
    case PAN_POSITIONS[1]:
      return "modalCheckboxPosition.center"
  }
  return ""
};

function shouldDisableCheckbox(parent, position) {
  const isBv5 = document.kvConfig.visualizerType === "bvScene";
  if (parent.partId === "shower_head" && !isBv5) {
    const target = parent.getParent().showerArm;
    // we can't use !target.layerPositions[position]
    // because disabling in modal one position makes it disabled
    return !!(target && !target.disabled && target.layerPositions && !target.getMatchingPositionFeature(position));
  }
  if (parent.partId === "seat_pad" && !shouldUseSafetyPackage(parent)) {
    const target = parent.getParent().seats;
    return !!(target && !target.disabled && target.layerPositions && !target.layerPositions[position]);
  }
  return false
}

const NavItemPositionModalButton = (props) => {

  const {position, parent, checkboxesUpdated, updateCheckboxes, changeMessageBoxState, intl, updateCanvasCount,
    activeFeature, canvasCount} = props;
  const [checked, setChecked] = useState(false);
  const positionName = getPositionName(position);

  const updateChecked = () => {
    const matchingPositionFeature = parent.getMatchingPositionFeature(position, activeFeature);
    const isChecked = parent.oneLayerPosition
      ? !parent.disabled && (parent.activeFeature && (parent.activeFeature.dbFeature.metaData["layerPosition"] === position))
      && matchingPositionFeature && (matchingPositionFeature.getSplittedFeatureName() === parent.activeFeature.getSplittedFeatureName())
      : !parent.disabled && parent.layerPositions && !!parent.layerPositions[position] && matchingPositionFeature
      && (matchingPositionFeature.getSplittedFeatureName() === parent.layerPositions[position].getSplittedFeatureName())
      && (document.kvConfig.visualizerType !== "bvScene" || !parent.hideLayerCondition || !parent.hideLayerCondition())

    setChecked(isChecked)
  };

  useEffect(() => {
    updateChecked();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkboxesUpdated, position, activeFeature, canvasCount]);

  const buttonClick = (event, fromConflictingPopup = false) => {
    if (parent.conflictingPositions && !fromConflictingPopup) { // shower_seats & valve_trim
      const conflictingPositions = parent.checkConflictingPosition(position, activeFeature);
      if (conflictingPositions.length) {
        callConflictingPopup(conflictingPositions);
        return
      }
    }
    if (parent.disabled) {
      parent.disabled = false;
      parent.disabledClick(); // disable also related parts
      if (!parent.oneLayerPosition) {
        Object.keys(parent.layerPositions).forEach(key => {
          if (key !== position) {
            parent.layerPositions[key] = null; // it can be only on one side on enable (if old feature exist and we clicked on another one)
          }
        })
      }
    }
    // const isBv5 = document.kvConfig.visualizerType === "bvScene";
    const matchingPositionFeature = parent.getMatchingPositionFeature(position, activeFeature);
    console.log("matchingPositionFeature", matchingPositionFeature);
    if (parent.oneLayerPosition) {
      matchingPositionFeature.handleClick(true); // to apply not compatible and so on // ignore locked as we it should be visible if clicked feature is unlocked
    } else {
      if (parent.isShowerCommonGroup && matchingPositionFeature && !checked) {
        // if (parent.partId === "shower_arm" && !isBv5) { // !! uncomment bv5 if we can't have different color on sides
        // removed on bv6 as well since we will use safety package there as well
        //   parent.checkForSameMountPosition(matchingPositionFeature); // this removes different mount position features
        // }
        matchingPositionFeature.handleClick(true); // set active feature and shower head type
      } else if (parent.partId === "shower_fixture" && matchingPositionFeature && !checked && parent.getParent().setShowerHeadType) {
        // parent.getParent().setShowerHeadType(ShowerHeadTypes.shower_fixture);
        matchingPositionFeature.handleClick(true); // set active feature and shower head type
      } else if (parent.partId === "replacement_tub_fixture"
        || parent.partId === "shower_head_bundle"
        || parent.partId === "hand_shower_kit"
        || parent.partId === "seat_pad") { // added seat pad to prevent changing it below in safety package change
        matchingPositionFeature.handleClick(true); // set tub combo // ignore locked as we it should be visible if clicked feature is unlocked
      }
      parent.layerPositions[position] = checked ? null : matchingPositionFeature;
      if (parent.isShowerCommonGroup) { // tool version 6 for now only
        parent.checkSameShowerPositionForAnotherFeatureGroup(position, matchingPositionFeature)
      }
        // && (!matchingPositionFeature || (parent.layerPositions[position].dbFeature.id === matchingPositionFeature.dbFeature.id))) { //already selected
    }
    if (parent.partId === "handle_shower_valve" && parent.checkForOneMountType) {
      parent.checkForOneMountType(matchingPositionFeature);
    }
    // const checkRelatedFeatureGroups = ["grab_bar", "soap_dish", "shower_seats", "large_corner_seat"];
    const checkRelatedFeatureGroups = ["shower_seats", "large_corner_seat"];
    if (checkRelatedFeatureGroups.includes(parent.partId)) {
      matchingPositionFeature.handleClick(true); // set active feature (for seats, to match seatPads)
      parent.checkRelatedFeatureGroupPositions(position, matchingPositionFeature);
      // if (parent.partId === "grab_bar") {
      //   parent.checkCurrentPositions(position);
      // }
    }
    if (allSafetyPackageGroups.includes(parent.partId) && shouldUseSafetyPackage(parent)) {
      updateFeatureGroupsWithNewSide(matchingPositionFeature, position);
    }
    if (parent.checkCenterGrabWall) {
      parent.checkCenterGrabWall(position);
    }
    if (updateCheckboxes) {
      updateCheckboxes(matchingPositionFeature);
    }
    $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS); // update footer items
    updateCanvasCount();
  };

  const checkboxDisabled = shouldDisableCheckbox(parent, position);

  const callConflictingPopup = (conflictingPositions) => {
    const message = {
      id: "messageBox.metaDataMatchesFailed",
      featureGroup: activeFeature.partId === "shower_seats" ? "Seat" : activeFeature.getParent().partName,
      featureName: activeFeature.getFeatureName(),
      nonCompatibleWith: conflictingPositions[0].getParent().partName,
    };
    changeMessageBoxState({
      visible: true,
      message,
      buttons: [{
        text: "messageBox.buttonNo",
        color: "blue",
        click: () => {
          changeMessageBoxState({visible:false});
        }
      }, {
        text: "messageBox.buttonYes",
        color: 'green',
        click: () => {
          parent.applyConflictingPosition(position, activeFeature);
          buttonClick({}, true);
          changeMessageBoxState({visible:false});
        }
      }]
    })
  }

  const disabledCheckboxClick = () => {
    if (parent.partId === "corner_shelf") { // disable top & center
      const matchingPositionFeature = parent.getMatchingPositionFeature(position, activeFeature);

      const featureIsLocked = getFeatureIsLocked(matchingPositionFeature);
      if (!featureIsLocked) {
        const message = {
          id: "messageBox.metaDataMatchesFailed",
          featureGroup: matchingPositionFeature.getParent().partName,
          featureName: intl.formatMessage({id: positionName}) + " " + matchingPositionFeature.getFeatureName(),
          nonCompatibleWith: "Window Kit"
        };
        changeMessageBoxState({
          visible: true,
          message,
          buttons: [{
            text: "messageBox.buttonYes",
            color: 'green',
            click: () => {
              const windowParent = parent.getParent().layout.parts.Window;
              windowParent.windowKits.disabled = true;
              buttonClick();
              changeMessageBoxState({visible:false});
            }
          },{
            text: "messageBox.buttonNo",
            color: "blue",
            click: () => {
              changeMessageBoxState({visible:false});
            }
          }]
        });
      }
    }
  }

  return (
    <button className="ui-checkbox-wrapper !flex flex--center"
            onClick={checkboxDisabled ? disabledCheckboxClick : buttonClick}>
      <span className={"ui-checkbox ui-checkbox--small"
      + (checked ? " ui-checkbox--checked" : "") + (checkboxDisabled ? " ui-checkbox--disabled" : "")}/>
      <span className={"ui-checkbox__label ui-checkbox__text" + (checkboxDisabled ? " ui-checkbox__label--disabled" : "")}>
        <FormattedMessage id={positionName}/>
      </span>
    </button>
  )
};

NavItemPositionModalButton.propTypes = {
  position: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  checkboxesUpdated: PropTypes.bool,
  updateCheckboxes: PropTypes.func,
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {canvasCount} = store.bathroomVisualizerState;
  return {
    navItemPositionModal: store.navigationState.navItemPositionModal,
    canvasCount,
  };
};

const mapDispatchToProps = {
  changeMessageBoxState,
  updateCanvasCount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(NavItemPositionModalButton)
)
